import React from 'react';

const SmartSurfaceScience = () => {
  const backgroundPattern = '/images/background/white-background-min.webp';
  const diamondLogo = '/images/background/about-diamond-min.webp';
  const carImage = '/images/background/about-car-min.webp';
  const title = "Tudo Começou Com Uma Ideia.";
  const paragraphs = [
    "Dessa inquietação surgiu uma ideia simples: \"Criar as superfícies mais bonitas, perfeitamente acabadas, inteligentes e avançadas do mundo. Selantes e produtos de limpeza para barcos, bicicletas e carros que fazem muito mais do que apenas deixar tudo bonito quando novo.\"",
    "A experiência de Drew lhe deu um entendimento profundo de como as forças, formas e estruturas de uma superfície funcionam em escalas microscópicas.",
    "Ele também sabia quais modificações poderiam trazer melhorias úteis. Aprimoramentos em selantes e proteção de pintura automotiva, como repelência à sujeira, facilidade de lavagem, resistência a riscos, proteção UV e contra manchas, além de brilho duradouro e estabilidade de cor a longo prazo."
  ];

  return (
    <div className="relative w-full bg-white overflow-hidden md:max-h-[768px]">
      {/* Background pattern */}
      <div 
        className="absolute inset-0 bg-cover bg-repeat" 
        style={{ 
          backgroundImage: `image-set(url(${backgroundPattern}) type('image/webp'), url(${backgroundPattern.replace(/\.webp$/i,'.jpg')}) type('image/jpeg'))`,
          backgroundPosition: 'var(--bg-position-x, 0%) var(--bg-position-y, 0%)',
          transition: 'background-position 0.5s ease-out',
        }}
      ></div>
      
      {/* Main content */}
      <div className="relative z-10 max-w-7xl mx-auto mt-10 md:mt-5 mb-10 md:mb-5 px-4 py-8 md:py-0 flex items-center">
        <div className="flex flex-col md:flex-row items-center md:space-x-12 lg:space-x-24">
          {/* Left side with diamond logo and car */}
          <div className="relative flex-shrink-0 w-[300px] h-[300px] md:w-[300px]  lg:w-[500px] lg:h-[500px] mb-8 md:mb-0">
            <div className="absolute inset-0 rounded-full flex  justify-center">
              <picture>
                <source srcSet={diamondLogo} type="image/webp" />
                <img src={diamondLogo.replace(/\.webp$/i, '.png')} alt="Logo de diamante" className="absolute -right-10 md:-right-16 lg:-right-20 w-[125%] max-w-none object-contain" />
              </picture>
            </div>
            <picture>
              <source srcSet={carImage} type="image/webp" />
              <img src={carImage.replace(/\.webp$/i, '.png')} alt="Carro esportivo vermelho" className="absolute -bottom-8 md:-bottom-10 lg:-bottom-12 -right-8 md:-right-16 w-[120%] max-w-none z-0" />
            </picture>
          </div>
          
          {/* Right side with text content */}
          <div className="max-w-xl ml-4 mr-4 mt-4">
          <div className="inline-block mb-4 relative">
                    <div className="relative">
                        <span className="bg-[#ff0000] text-white font-semibold px-4 py-1 inline-block relative z-10">
                            Smart Surface Science
                        </span>
                        <span 
                          className="absolute top-0 right-0 bottom-0 bg-[#ff0000] transform -skew-x-12" 
                            style={{ 
                                width: '100%',
                                transformOrigin: 'bottom right'
                         }}
                        ></span>
    
                    </div>
                </div> 
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-gray-800">{title}</h1>
            {paragraphs.map((paragraph, index) => (
              <p key={index} className="text-gray-600 mb-3 md:mb-4 text-base md:text-lg">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartSurfaceScience;
